import React, { Component } from 'react'
import { connect } from 'react-redux'

import { updatePage } from '../../../redux/help'

import HelpManual from './component'

class HelpManualContainer extends Component {
  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  render () {
    return (
      <HelpManual
        currentPage={this.props.currentPage}
        updatePage={this.props.updatePage}
        sidebarWidth={this.props.sidebarWidth}
        totalPages={this.props.totalPages}
        filesToDownload={this.props.filesToDownload}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'HelpManual',
  currentPage: state.help.currentPage,
  totalPages: state.help.totalPages,
  sidebarWidth: state.ui.sidebarWidth,
  filesToDownload: state.files.filesToDownload
})

export default connect(mapStateToProps, {
  updatePage
})(HelpManualContainer)
